import { action, computed, observable, runInAction } from 'mobx';

import { userStore } from './UserStore';
import request from '../common/utils/Request';

import { DataLoadStatus, InputHighlight, SelfEvaluation, ProgramTopicsGetData } from '../types';

class SelfEvaluationEditorStore {
  private static _instance: SelfEvaluationEditorStore;

  @observable public awaitServer: boolean = false;
  @observable public edittingBlockId: number = 0;
  @observable public id: number = 0;
  @observable public isEditModalActive: boolean = false
  @observable public loadStatus: DataLoadStatus = DataLoadStatus.NOT_STARTED;
  @observable public programId: number = 0;
  @observable public programName: string =  '';
  @observable public programNameBlurred: boolean =  false;
  @observable public programTopics: ProgramTopicsGetData[] = [];
  @observable public question: string = '';
  @observable public questionChanged: boolean = false;
  @observable public score: number =  0;
  @observable public scoreBlurred: boolean =  false;
  @observable public selfEvaluations: SelfEvaluation[] = [];

  /**
   * Use Programtore.instance to retrieve an instance of this class.
   */
  private constructor() { }

  /**
   * Instance of ProgramStore.
   */
  public static get instance() {
    if (!this._instance) {
      this._instance = new SelfEvaluationEditorStore();
    }

    return this._instance;
  }

  @computed
  public get isProgramNameValid(): boolean {
    return this.programNameBlurred ? this.programName !== '' : true;
  }

  @computed
  public get programNameHelpMessage(): string {
    return this.isProgramNameValid ? '' : 'Please select a program';
  }

  @computed
  public get programNameHighlight(): InputHighlight {
    return this.isProgramNameValid ? InputHighlight.INFO : InputHighlight.DANGER;
  }

  @computed
  public get isScoreValid(): boolean {
    return this.scoreBlurred ? this.score !== 0 : true;
  }

  @computed
  public get scoreHelpMessage(): string {
    return this.isScoreValid ? '1 = beginner, 10 = expert' : 'Please evaluate yourself on this program';
  }

  @computed
  public get scoreHighlight(): InputHighlight {
    return this.isScoreValid ? InputHighlight.INFO : InputHighlight.DANGER;
  }

  @action
  public checkReadyForSave = (): boolean => {
    this.programNameBlurred = true;
    this.scoreBlurred = true;
    return this.isProgramNameValid && this.isScoreValid;
  }

  @action
  public loadProgramTopics = async () => {
    // Do not get program topics unless user is signed in
    if (userStore.isSignedIn) {
      try {
        this.loadStatus = DataLoadStatus.LOADING;
        const { data } = await request.get('/program_topics/');
        
        runInAction(() => {
          this.programTopics = data;
          this.loadStatus = DataLoadStatus.LOADED
        });
      } catch (err) {
        runInAction(() => {
          this.loadStatus = DataLoadStatus.FAILED;
        });

        throw err;
      }
    }
  }
}

export default SelfEvaluationEditorStore;
export const selfEvaluationEditorStore = SelfEvaluationEditorStore.instance;


// WEBPACK FOOTER //
// ./src/stores/SelfEvaluationEditorStore.ts